import { useMemo } from "react";
import { SearchAndFilterTypes } from "src/constants";
import { useOrganization } from "src/hooks/useOrganization";
import { useRemoteDataQuery } from "src/hooks/useRemoteDataQuery";
import { GET_GRADES_CONFIG_BY_ORGANIZATION } from "src/scenes/orgAdmin/formTemplates/graphql/queries";
import * as GQL from "src/types/graphql";
import {
  CommonFilterProps,
  FormFilter,
  MultiSelectFilter,
} from "../CommonFilters";

export const GradeFilter = (props: CommonFilterProps) => {
  const organization = useOrganization();

  const { remoteData: gradesRemoteData } = useRemoteDataQuery<
    GQL.GetGradesConfigByOrganization,
    GQL.GetGradesConfigByOrganizationVariables
  >(GET_GRADES_CONFIG_BY_ORGANIZATION, {
    skip: !organization.hasData(),
    variables: {
      organizationId: organization.toNullable()?.id ?? "",
    },
    fetchPolicy: "cache-first",
  });
  const options = useMemo(
    () => gradesRemoteData.toNullable()?.grade_config ?? [],
    [gradesRemoteData]
  );

  return (
    <FormFilter label="Grade applying to">
      <MultiSelectFilter
        filterKey={SearchAndFilterTypes.Grades}
        options={options}
        {...props}
      />
    </FormFilter>
  );
};
